import { useRef } from "react";
import * as theme from "../theme";
import "../general/EachFormNavTab.css";
import FormNavHeader from "../formnavigation/FormNavHeader";

// Adapted from EachFormNavTab

const BugReportNavTab = ({ openFormId, formid, text, onHeaderClick }) => {
  const thisFormRef = useRef(null);
  return (
    <div
      ref={thisFormRef}
      style={{
        display: "flex",
        cursor: "pointer",
        minHeight: theme.SCALES.qfNavTabHeaderHeight,
        borderBottom: `2px solid ${theme.COLORS.navigation_in_between_line_color}`,
      }}
    >
      <div style={{ width: "100%" }}>
        <FormNavHeader
          isopen={openFormId === formid}
          formtype={"Bug Report"}
          text={text}
          isFormExpandable={false}
          formid={formid}
          handleOnClick={() => onHeaderClick(formid)}
        ></FormNavHeader>
        {/* The orange add button is from FormNavHeader, only added if the formtype is Locations */}
      </div>
    </div>
  );
};

export default BugReportNavTab;
